<template>
    <div class="services-sms-create">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Criar Campanha</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulário da Campanha -->
        <mu-form-sms></mu-form-sms>

    </div>
</template>

<script>
    export default {
        name: 'services-sms-create-dashboard',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Campanhas',
                        route: 'app.services.sms',
                        disabled: false
                    },
                    {
                        text: 'Criar Campanha',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
